import React from 'react';
import PropTypes from 'prop-types';

import { PrintSize } from '../../../prop-types';
import PandaViewSimplePreviews from '../../../common/panda-view-simple-previews';

const SimpleThumbnail = props => {
  const { photo, recommendedPrintSize, layoutProps } = props;

  return (
    <PandaViewSimplePreviews
      {...photo}
      isWallet={photo.size.title === 'Wallet'}
      size_area={photo.size.area}
      showSize={false}
      showQuantity={false}
      recommendedPrintSize={recommendedPrintSize}
      {...layoutProps}
    />
  );
};

SimpleThumbnail.propTypes = {
  photo: PrintSize,
  isLastPhoto: PropTypes.bool,
  availableSizes: PropTypes.arrayOf(PrintSize),
  sizesWithRootImage: PropTypes.arrayOf(PrintSize),
  onAdvancedEdit: PropTypes.func,
  layoutProps: PropTypes.object,
  isSelected: PropTypes.bool,
};

SimpleThumbnail.defaultProps = {
  layoutProps: {},
  isSelected: false,
};

export default SimpleThumbnail;
